import { createFileRoute } from "@tanstack/react-router";

import { About } from "@/components/site/About";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Hero } from "@/components/site/Hero";
import { PhotoGallery } from "@/components/site/PhotoGallery";
import { Reviews } from "@/components/site/Reviews";
import { Services } from "@/components/site/Services";
import { ShopFloor } from "@/components/site/ShopFloor";
import { SiteShell } from "@/components/site/SiteShell";
import { faqs } from "@/lib/business";
import { heroImage } from "@/lib/images";
import { localBusinessJsonLd, pageHead } from "@/lib/seo";

const title = "Engine Machine Shop in Enterprise, AL | Champion Automotive";
const description =
  "Champion Automotive Machine Shop in Enterprise, AL: cylinder boring, sleeving, valve work, line boring, balancing, lathe work, and block & head surfacing for auto, diesel, tractor & motorcycle engines. Call (334) 393-5401.";

export const Route = createFileRoute("/")({
  component: Index,
  head: () => {
    const seo = pageHead({ title, description, path: "/" });
    return {
      ...seo,
      links: [
        ...(seo.links ?? []),
        {
          rel: "preload",
          as: "image",
          href: "/images/hero-engine-1024.avif",
          type: "image/avif",
          imageSrcSet: heroImage.avif,
          imageSizes: "100vw",
          fetchPriority: "high",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(localBusinessJsonLd(description)),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: { "@type": "Answer", text: faq.a },
            })),
          }),
        },
      ],
    };
  },
});

function Index() {
  return (
    <SiteShell>
      <Hero />
      <ShopFloor />
      <PhotoGallery />
      <Services />
      <About />
      <Reviews />
      <Faq />
      <Contact />
    </SiteShell>
  );
}
